import { Head, usePage } from '@inertiajs/react'
import GalaTicketPricingPlanner from '@/components/GalaTicketPricingPlanner'
import type { SharedProps } from '@/types'

const TITLE = 'Gala Ticket Pricing Calculator | Free Planner for Nonprofits'
const DESCRIPTION =
  'Free planner that sets a realistic gala ticket price and a sponsorship ladder sized to hit your fundraising goal. Built for nonprofit galas and benefits.'
const OG_TITLE = 'Gala Ticket & Sponsorship Planner'

export default function GalaTicketPricingPlannerPage() {
  const { app_url } = usePage<SharedProps>().props
  const canonical = `${app_url}/gala-ticket-pricing-planner`
  const ogImage = `${app_url}/meta.png`

  return (
    <>
      <Head title={TITLE}>
        <meta head-key="description" name="description" content={DESCRIPTION} />
        <meta head-key="og:title" property="og:title" content={OG_TITLE} />
        <meta head-key="og:description" property="og:description" content={DESCRIPTION} />
        <meta head-key="og:type" property="og:type" content="website" />
        <meta head-key="og:url" property="og:url" content={canonical} />
        <meta head-key="og:image" property="og:image" content={ogImage} />
        <meta head-key="twitter:card" name="twitter:card" content="summary_large_image" />
        <meta head-key="twitter:title" name="twitter:title" content={OG_TITLE} />
        <meta head-key="twitter:description" name="twitter:description" content={DESCRIPTION} />
        <meta head-key="twitter:image" name="twitter:image" content={ogImage} />
        <link head-key="canonical" rel="canonical" href={canonical} />
      </Head>

      <div className="relative overflow-hidden bg-linear-to-br from-[oklch(0.25_0.02_50)] via-[oklch(0.35_0.10_46)] to-primary">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(255,255,255,0.12),transparent)]" />
        <div className="relative mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-16 lg:px-8 lg:py-20">
          <h1 className="max-w-[24ch] text-4xl font-semibold tracking-tight text-white text-balance sm:text-5xl">
            Gala Ticket &amp; Sponsorship Planner
          </h1>
          <p className="mt-4 max-w-[62ch] text-lg font-medium text-white/85 text-pretty">
            Work backward from your fundraising goal to a realistic ticket price and a sponsorship
            ladder sized to close the gap &mdash; with a live goal check as you go.
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
        <GalaTicketPricingPlanner />
      </div>
    </>
  )
}
